//import { getFormDataFromObject, isObjEmpty } from "../js/helper";
import { getFormDataFromObject, sortArrayByObjProps } from "../js/helper";
import APIMETHODS from "../js/api-methods";
let qs = require('qs');

String.prototype.format = function (e) { var t = this; if (arguments.length > 0) if (arguments.length == 1 && typeof e == "object") { for (var n in e) if (e[n] != undefined) { var r = new RegExp("({" + n + "})", "g"); t = t.replace(r, e[n]) } } else for (var i = 0; i < arguments.length; i++) if (arguments[i] != undefined) { var r = new RegExp("({)" + i + "(})", "g"); t = t.replace(r, arguments[i]) } return t };
String.prototype.subStrEx = function (e) { return this.length + 3 > e ? this.substr(0, e) + "..." : this };

export default {
	state: () => ({
		SimCommands: []
	}),
	mutations: {
		SET_SIM_COMMANDS(state, items) {
		//	console.log(items)
			state.SimCommands = [{ Name: 'Custom command', Code: 'custom' }].concat(items)
		},
	},
	getters: {
		SimCommands: s => s.SimCommands,
	},
	actions: {
		async GET_SESSION_DATA({ commit, rootState }, query) {
			try {
				let data = getFormDataFromObject(query)
				let response = await fetch(APIMETHODS.GET_SESSION_DATA, {
					method: "POST",
					body: data,
					headers: {
						'token': rootState.RootToken
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'GET_SESSION_DATA';
					//commit('SET_ERROR', response)

					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'GET_SESSION_DATA';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},

		async GET_SMS_HISTORY({ commit, rootState }, query) {
			try {
				console.log('rootState', rootState)
				let data = getFormDataFromObject(query)
				let response = await fetch(APIMETHODS.GET_SMS_HISTORY, {
					method: "POST",
					body: data,
					headers: {
						'token': rootState.RootToken
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'GET_SMS_HISTORY';
					//commit('SET_ERROR', response)

					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'GET_SMS_HISTORY';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},

		async GET_TCP_HISTORY({ commit }, query) {
			try {

				const {
					from,
					to,
					numbers
				} = query

				let url = APIMETHODS.GET_TCP_HISTORY.format(
					encodeURIComponent(from),
					encodeURIComponent(to),
					encodeURIComponent(numbers),
				)

				let response = await fetch(url);

				response = await response.json();
				if (response) {
					return response
				} else {
					response.method = 'GET_TCP_HISTORY';
					//commit('SET_ERROR', response)

					console.log('SET_ERROR', response)
					return false
				}

			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'GET_TCP_HISTORY';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		/*
		async GET_TCP_HISTORY({commit, rootState }, query){
		  try {
			let data = getFormDataFromObject(query)
			let response = await fetch(APIMETHODS.GET_TCP_HISTORY, {
			  method: "GET",
			  //body: data,
			  headers: {
				'token': rootState.RootToken
			  }
			});
			response = await response.json();
			if(response.MajorCode === '000'){
			  return response.Data
			}else{
			  response.method = 'GET_TCP_HISTORY';
			  //commit('SET_ERROR', response)
			  
			  console.log('SET_ERROR', response)
			  return false
			}
		  } catch (e) {
			if(e && e.response && e.response.data) e.response.data.method = 'GET_TCP_HISTORY';
			commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
			throw e
		  }
		},*/

		async GET_SIM_LIST({ commit, rootState }, query) {
			try {
				let data = getFormDataFromObject(query)
				let response = await fetch(APIMETHODS.GET_SIM_LIST, {
					method: "POST",
					body: data,
					headers: {
						'token': rootState.RootToken
					}
				});
				response = await response.json();
				if (response) {//.MajorCode === '000'
					return response
				} else {
					response.method = 'GET_SIM_LIST';
					//commit('SET_ERROR', response)

					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'GET_SIM_LIST';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},

		async SIM_SET_SERVICE_PROFILE({ commit, rootState }, query) {
			try {
				let data = getFormDataFromObject(query)
				let response = await fetch(APIMETHODS.SIM_SET_SERVICE_PROFILE, {
					method: "POST",
					body: data,
					headers: {
						'token': rootState.RootToken
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'SIM_SET_SERVICE_PROFILE';
					//commit('SET_ERROR', response)

					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'SIM_SET_SERVICE_PROFILE';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},

		async SIM_SET_ACTIVATE({ commit, rootState }, query) {
			try {
				let data = getFormDataFromObject(query)
				let response = await fetch(APIMETHODS.SIM_SET_ACTIVATE, {
					method: "POST",
					body: data,
					headers: {
						'token': rootState.RootToken
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'SIM_SET_ACTIVATE';
					//commit('SET_ERROR', response)

					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'SIM_SET_ACTIVATE';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async SIM_SET_SUSPEND({ commit, rootState }, query) {
			try {
				let data = getFormDataFromObject(query)
				let response = await fetch(APIMETHODS.SIM_SET_SUSPEND, {
					method: "POST",
					body: data,
					headers: {
						'token': rootState.RootToken
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'SIM_SET_SUSPEND';
					//commit('SET_ERROR', response)

					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'SIM_SET_SUSPEND';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async SIM_SET_RESUME({ commit, rootState }, query) {
			try {
				let data = getFormDataFromObject(query)
				let response = await fetch(APIMETHODS.SIM_SET_RESUME, {
					method: "POST",
					body: data,
					headers: {
						'token': rootState.RootToken
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'SIM_SET_RESUME';
					//commit('SET_ERROR', response)

					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'SIM_SET_RESUME';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async SIM_SET_TERMINATE({ commit, rootState }, query) {
			try {
				let data = getFormDataFromObject(query)
				let response = await fetch(APIMETHODS.SIM_SET_TERMINATE, {
					method: "POST",
					body: data,
					headers: {
						'token': rootState.RootToken
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'SIM_SET_TERMINATE';
					//commit('SET_ERROR', response)

					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'SIM_SET_TERMINATE';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async SIM_REPLACE({ commit }, query) {
			try {
				let data = new URLSearchParams(query).toString()
				let response = await fetch(APIMETHODS.SIM_REPLACE + '?' + data);
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'SIM_REPLACE';
					//commit('SET_ERROR', response)

					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'SIM_REPLACE';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},

		async SIM_GET_COMMANDS_TYPES({ commit }, query) {
			try {
				let data = new URLSearchParams(query).toString()
				var requestOptions = {
					method: 'POST',
					redirect: 'follow'
				};
				let response = await fetch(APIMETHODS.SIM_GET_COMMANDS_TYPES + '?' + data, requestOptions);
				response = await response.json();
				if (response && Array.isArray(response) && response.length) {
					//commit('SIM_GET_COMMANDS_TYPES', sortArrayByObjProps(response, [{prop: 'Name', direction: 1}]))
					return response
				} else {
					return []
				}

			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'SIM_GET_COMMANDS_TYPES';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async SIM_GET_COMMANDS({ commit }, query) {
			try {
				let data = new URLSearchParams(query).toString()
				let response = await fetch(APIMETHODS.SIM_GET_COMMANDS + '?' + data);
				response = await response.json();
			//	console.log('r', response)
				if (response && Array.isArray(response) && response.length) {
					//commit('SET_SIM_COMMANDS', response)
					commit('SET_SIM_COMMANDS', sortArrayByObjProps(response, [{ prop: 'Name', direction: 1 }]))
					return response
				} else {
					return []
				}

			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'SIM_GET_COMMANDS';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},

		async SIM_SEND_COMMAND_BY_TCP({ commit }, query) {
			try {
				let data = qs.stringify(query)
				let response = await fetch(APIMETHODS.SIM_SEND_COMMAND_BY_TCP, {
					method: "POST",
					body: data,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'SIM_SEND_COMMAND_BY_TCP';
					//commit('SET_ERROR', response)

					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'SIM_SEND_COMMAND_BY_TCP';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async SIM_SEND_COMMAND({ commit }, query) {
			try {
				let data = qs.stringify(query)
				let response = await fetch(APIMETHODS.SIM_SEND_COMMAND, {
					method: "POST",
					body: data,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return response.Data
				} else {
					response.method = 'SIM_SEND_COMMAND';
					//commit('SET_ERROR', response)

					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'SIM_SEND_COMMAND';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async TRANSFER_TO_CUSTOMER({ commit }, query) {
			try {
				let data = qs.stringify(query)
				let response = await fetch(APIMETHODS.TRANSFER_TO_CUSTOMER, {
					method: "POST",
					body: data,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return true
				} else {
					response.method = 'TRANSFER_TO_CUSTOMER';
					//commit('SET_ERROR', response)

					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'TRANSFER_TO_CUSTOMER';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
		async IMPORT_ASSETS({ commit }, query) {
			try {
				let data = qs.stringify(query)
				let response = await fetch(APIMETHODS.IMPORT_ASSETS, {
					method: "POST",
					body: data,
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				});
				response = await response.json();
				if (response.MajorCode === '000') {
					return true //response.Data
				} else {
					response.method = 'IMPORT_ASSETS';
					response.query = query;
					response.sendErrorEmail = true;
					response.saveError = true;
					commit('SET_ERROR', response)
					console.log('SET_ERROR', response)
					return false
				}
			} catch (e) {
				if (e && e.response && e.response.data) e.response.data.method = 'IMPORT_ASSETS';
				commit('SET_ERROR', !e.response ? e : (!e.response.data) ? e.response : e.response.data)
				throw e
			}
		},
	}
}